<!-- New theme (Beta) -->
<ng-container *ngIf="newThemeActive$ | async; else oldApplicationDetails">
    <app-application-details></app-application-details>
</ng-container>

<!-- Old theme -->
<ng-template #oldApplicationDetails>
    <app-old-application-details></app-old-application-details>
</ng-template>
